import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const ShoppingCartSimpleFull: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <circle cx='640' cy='225' r='45' />
    <circle cx='280' cy='600' r='30' />
    <circle cx='550' cy='600' r='30' />
    <path d='m265 240h75v-30s-45 0-45 0c-16.57 0-30 13.43-30 30z' />
    <path d='m576.64 540h-324.35l-60-360h-42.29v-30h67.71l60 360h275.65l61.64-211.51c16.05 4.12 25.72 20.46 21.61 36.51z' />
    <path d='m319.37 210h245.63v30h-245.63z' />
    <path d='m100 180h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

ShoppingCartSimpleFull.displayName = 'ShoppingCartSimpleFull';

export default ShoppingCartSimpleFull;
